import { render, staticRenderFns } from "./cacheList.vue?vue&type=template&id=28868dd4&scoped=true"
import script from "./cacheList.vue?vue&type=script&lang=js"
export * from "./cacheList.vue?vue&type=script&lang=js"
import style0 from "./cacheList.vue?vue&type=style&index=0&id=28868dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28868dd4",
  null
  
)

export default component.exports